"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showUnionInterpreter = void 0;
var utils_1 = require("@morphic-ts/common/lib/utils");
var hkt_1 = require("./../hkt");
/**
 *  @since 0.0.1
 */
exports.showUnionInterpreter = utils_1.memo(function () { return ({
    _F: hkt_1.ShowURI,
    union: function (items) { return function (guards, _name) { return function (env) {
        var items_ = items.map(function (_) { return _(env).show.show; });
        var guardId = utils_1.getGuardId(guards, Symbol());
        return new hkt_1.ShowType({
            show: function (a) { return items_[guardId(a)](a); }
        });
    }; }; }
}); });
